// imports shared across all ORA templates
require('../ora/base/imports');

// modules
require('../../js/site_scripts/mtc_recaptcha_init_v3');
require('../../js/site_scripts/mtc_submit_form');
require('../../js/site_scripts/mtc_enquiry_form_overlay');

// ORA page styles
require('../../styles/entry/ora-corporate-offers.less')
